module.exports = __webpack_public_path__ + "img/Dr. H. Anwar Abbas, M.M, M.Ag  - Ketua DPS.7e86c2e3.jpg";